export enum UserTypeEnum {
    DOCTOR = 0,
    EXPERT = 1,
    ADMIN = 2,
    FIRST_AID = 3,
}